import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import {
  useLazyMmcListQuery,
  useLazyMmcStatusQuery,
} from "../../redux/api/api";
import { editIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";

const MMCList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [row, setRow] = useState(10);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [mmcListApi] = useLazyMmcListQuery();
  const [mmcStatusApi] = useLazyMmcStatusQuery();

  const getMMC = (search_value, row_value) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setSearch(search_value);
    setRow(row_value);
    dispatch(saveLoader(true));
    mmcListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.subscriptions);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getMMC(search, row);
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    mmcStatusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getMMC(search, row);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"mcc-list"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {pagination?.total}
              </label>
            </Col>
            <Col sm={6} md={6}>
              <div className="d-flex ac-je block-header add-btn">
                <button className="f1 d-flex" onClick={() => navigate("/mcc")}>
                  <AddIcon />
                  Add MCC
                </button>
              </div>
            </Col>
          </Row>
          <div className="d-flex ac-jb">
            <div className="col-md-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) => getMMC(search, e.target.value)}
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="mb-2">
              <input
                className="form-control bg-white"
                placeholder="Search..."
                style={{ width: "300px" }}
                onChange={(e) => getMMC(e.target.value, row)}
                value={search}
              />
            </div>
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize">
                  <th>S.NO</th>
                  <th>Name</th>
                  <th>Plan id</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>{item?.name ? item?.name : "-"}</td>
                      <td>{item?.plan_id}</td>
                      <td>{item?.amount}</td>
                      <td>
                        <button
                          className={`${
                            item?.status == 1 ? "btn-success" : "btn-danger"
                          } px-2 py-1 rounded-1 border-0 text-white`}
                          onClick={() => statusChange(item?.id)}
                          disabled={btn}
                        >
                          {item?.status == 1 ? "Active" : "Deactive"}
                        </button>
                      </td>
                      <td>
                        <button
                          className="cust-btn"
                          onClick={() =>
                            navigate("/mcc", {
                              state: { type: "edit", data: item },
                            })
                          }
                        >
                          <img src={editIcon} className="edit-btn" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default MMCList;
